import React from "react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { Button } from "@/components/ui/button";

interface WalletProps {
  children: React.ReactNode;
  isBlurred?: boolean;
}

/** Main wallet panel — balance, actions, and token list. */
const Wallet = ({ children, isBlurred = false }: WalletProps) => (
  <div className="relative w-full">
    <section
      id="wallet"
      data-testid="wallet"
      aria-label="Wallet"
      className="relative w-full rounded-3xl welcome-card p-4 sm:p-6 flex flex-col gap-3 sm:gap-6 overflow-hidden"
      style={{
        filter: isBlurred ? "blur(3px)" : "none",
        transition: "filter 0.5s ease-out",
        pointerEvents: isBlurred ? "none" : undefined,
      }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-[1.5px]"
        style={{ background: "linear-gradient(90deg, #bea7ff 0%, #798af2 50%, #7bc6ff 100%)" }}
        aria-hidden="true"
      />
      {children}
    </section>

    {isBlurred && (
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 z-10 bg-white/70 dark:bg-[#070e2a]/70 rounded-3xl backdrop-blur-sm">
        <p className="text-sm font-medium text-muted-foreground">Connect your wallet to get started</p>
        <ConnectButton.Custom>
          {({ openConnectModal, mounted }) => (
            <Button
              onClick={openConnectModal}
              disabled={!mounted}
              className="transition-all duration-300 rounded-full font-display font-medium text-sm px-6 h-10 btn-gradient-connect"
            >
              Connect Wallet
            </Button>
          )}
        </ConnectButton.Custom>
      </div>
    )}
  </div>
);

export default Wallet;
